export const ROOT_PATH = '/';

export const DASHBOARD_PATH = '/dashboard';

export const RESUME_PATH = '/resume';
export const RESUME_FEEDBACK_PATH = RESUME_PATH + '/feedback';
export const RESUME_EDIT_PATH = RESUME_PATH + '/edit';
export const RESUME_ANNUAL_INCOME_EDIT_PATH = RESUME_PATH + '/annual_income';
export const RESUME_MANAGEMENT_PATH = RESUME_PATH + '/management';
export const RESUME_CHARACTER_PATH = RESUME_PATH + '/character';
export const RESUME_WANT_DO_PATH = RESUME_PATH + '/want_do';
export const RESUME_PROFILE_PATH = RESUME_PATH + '/profile';
export const RESUME_OUTSOURCING_SETTING_PATH = RESUME_PATH + '/outsourcing_setting';

export const MESSAGE_DETAIL_PATH = '/message/:messageId';

export const SETTING_PATH = '/setting';

export const PROFILE_PATH = '/profile';
export const PROFILE_AI_IMPORT_PATH = `${PROFILE_PATH}/ai-import`;

export const MYPAGE_PATH = '/profile';

export const MESSAGE_PATH = '/messages';

export const SCOUTS_PATH = '/scouts';
export const SCOUT_DETAIL_PATH = '/scouts/:scoutId';

export const CONTRACTS_PATH = '/contracts';
export const CONTRACT_DETAIL_PATH = '/contracts/:contractId';

export const WORK_REPORTS_PATH = '/work-reports';
export const WORK_REPORT_DETAIL_PATH = '/work-reports/:reportId';
export const WORK_REPORT_NEW_PATH = '/work-reports/new';
export const WORK_REPORT_EDIT_PATH = '/work-reports/:reportId/edit';

export const INVOICES_PATH = '/invoices';
export const INVOICE_DETAIL_PATH = '/invoices/:invoiceId';

export const PROFILE_REGISTER_PATH = '/profile-register';

export const AGENT_PATH = '/agent';

export const LOGIN_PATH = '/login';
export const SIGN_UP_PATH = '/signup';
export const AUTH_EMAIL_PENDING_PATH = '/auth-email/pending';
export const AUTH_EMAIL_COMPLETE_PATH = '/auth-email/complete';
export const AUTH_PHONE_VERIFY_PATH = '/auth-phone/verify';
export const PASSWORD_RESET_COMPLETE_PATH = '/password-reset/complete';

export const NOT_FOUND_PATH = '*';

export const MARKETING_LP_URL = 'https://comm.relance.jp/';

export const EMAIL_CHANGE_PATH = '#' as const;
export const PASSWORD_CHANGE_PATH = '#' as const;

export const MYPAGE_TABS = [
  {
    label: '基本情報',
    param: 'profile',
  },
  {
    label: 'スキルセット・経歴',
    param: 'skill',
  },
  {
    label: '希望条件',
    param: 'condition',
  },
];
